export default __webpack_public_path__ + "static/creator-bundle-photo-f30abe1ad7365c905c1ba7ecfc1f5c92.png";